import React, { useEffect, useState } from "react";
import axios from "axios";
import { Tag, Modal, Typography, message } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { ButtonItem, ListaItems } from "../../../../../Components/Items";
import { WA } from "../../theme";
import EditorUbicacion from "../Editores/EditorUbicacion";

const { Text } = Typography;

// Administra las ubicaciones por defecto reutilizables (CRUD).
const BibliotecaUbicaciones = ({ headersToken, empresaId }) => {
  const [ubicaciones, setUbicaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editor, setEditor] = useState({ visible: false, ubicacion: null });

  const headers = { headers: headersToken };

  const cargar = () => {
    setLoading(true);
    axios
      .post("whatsapp/ubicacionListar", { empresaId }, headers)
      .then((r) => {
        if (r.data.success === 2) setUbicaciones(r.data.ubicaciones || []);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cerrarEditor = (recargar) => {
    setEditor({ visible: false, ubicacion: null });
    if (recargar) cargar();
  };

  const eliminar = (ubicacion) => {
    Modal.confirm({
      title: "Eliminar ubicación",
      content: `¿Eliminar "${ubicacion.nombre}"? Esta acción no se puede deshacer.`,
      okText: "Eliminar",
      okButtonProps: { danger: true },
      cancelText: "Cancelar",
      zIndex: 1300,
      onOk: () =>
        axios
          .post("whatsapp/ubicacionEliminar", { ubicacionId: ubicacion._id }, headers)
          .then((r) => {
            if (r.data.success === 2) {
              message.success("Ubicación eliminada.");
              setUbicaciones((prev) => prev.filter((u) => u._id !== ubicacion._id));
            } else {
              message.error(r.data.message || "No se pudo eliminar.");
            }
          })
          .catch(() => message.error("Error de red al eliminar.")),
    });
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
        <ButtonItem
          cyan
          icon={<PlusOutlined />}
          onClick={() => setEditor({ visible: true, ubicacion: null })}
        >
          Nueva ubicación
        </ButtonItem>
      </div>

      <ListaItems
        dataSource={ubicaciones}
        loading={loading}
        vacioTexto="Aún no hay ubicaciones guardadas"
        titulo={(u) => (
          <Text style={{ color: WA.textPrimary }}>
            <EnvironmentOutlined style={{ color: WA.turquesa, marginRight: 6 }} />
            {u.nombre}
          </Text>
        )}
        descripcion={(u) => (
          <>
            {u.descripcion && (
              <div style={{ fontSize: 12, color: WA.textSecondary }}>{u.descripcion}</div>
            )}
            <Tag color={WA.naranja} style={{ marginTop: 4 }}>
              {Number(u.latitude).toFixed(5)}, {Number(u.longitude).toFixed(5)}
            </Tag>
          </>
        )}
        acciones={(u) => [
          <ButtonItem key="edit" lima icon={<EditOutlined />} onClick={() => setEditor({ visible: true, ubicacion: u })} />,
          <ButtonItem key="del" rojo icon={<DeleteOutlined />} onClick={() => eliminar(u)} />,
        ]}
      />

      <EditorUbicacion
        visible={editor.visible}
        headersToken={headersToken}
        empresaId={empresaId}
        ubicacion={editor.ubicacion}
        onCancel={() => cerrarEditor(false)}
        onGuardado={() => cerrarEditor(true)}
      />
    </>
  );
};

export default BibliotecaUbicaciones;
